<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Notice of Decision</h3>
       </template>
       <nav class="row">
          <ol class="breadcrumb arr-right bg-breadcrum">
             <li class="breadcrumb-item">
                <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
             </li>
             <li class="breadcrumb-item">
                <router-link to="/hr/nterequest">NTE Tracker</router-link>
             </li>
             <li class="breadcrumb-item active">Notice of Decision</li>
          </ol>
       </nav>
       <hr style="margin-top:-10px" />
       <div class="report-container">
          <img width="190" height="110" src="/static/img/blueprintlogo.png" alt="..." />
          <br/>
          <br/>
          <div class="col-md-12 report-border-full">
             <span class="report-header-nte">NOTICE TO EXPLAIN</span>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <div class="row">
                <div class="col-md-4">
                   <b>Employee Name :</b> {{item.full_name | capitalize}}
                   <br/>
                   <b>Supervisor Name : </b>{{item.superior_name}}
                </div>
                <div class="col-md-4">
                   <b>Date Notice : </b>{{getDate(item.date_incident)}}
                   <br/>
                   <b>Position :</b> {{item.position_name}}
                </div>
                <div class="col-md-4">
                   <b>ID No. : </b>{{item.emp_no}}
                   <br/>
                </div>
             </div>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <b>Type of Infraction :</b>
             <br/>{{item.type_of_infraction}}<br/><br/>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <b>Details of Occurence :</b>   
             <span v-for="(res,i) in item.occurence">
             <br/><b>{{i+1}}</b>.&nbsp;&nbsp;{{res.date}} &nbsp;&nbsp; {{res.details}}
             </span>
             <br/><br/>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             {{item.details_of_infraction}}
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <b>Corrective Action To be Taken :</b><br/>
             <div v-if="item.action_to_be_taken != 0 "><i class="fa fa-dot-circle-o"></i>&nbsp; {{item.action_to_be_taken}}</div>
             <br/>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <b>Explanation :</b>
             <br/>
             <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.plan_for_improvement}}</pre>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <b>Employee's Commitment :</b>
             <br/>
             <pre style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.employees_commitment}}</pre>
             <br/>
             <br/>
          </div>
          <br/>
          <br/>
          <br/>
          <p>  I hereby acknowledge that I have been coached according to standard set by the company and commit to the objectives and targets stated above. </p>
          <br/><br/>     
          <!-- SIGNATURE-SECTION -->    
          <div class="row">
             <div class="col-md-8">
             </div>
             <div class="col-md-4">
                <br/><br/>
                <div v-if="item.signature == ''">
                        <div class="report-signature-container">    
                          <p style="color:red">No signature found.</p>
                        </div>   
                </div> 
                 <div v-else>   
                    <div class="report-signature-container">    
                    <img class="report-signature-control"  :src="item.signature" alt="..."/>
                    <div class="report-printed-control"><b> {{item.full_name | uppercase}}</b></div>
                    <div class="report-line-divider"></div>
                    <center> Employee Signature</center>
                    </div>    
                </div>   
             </div>
          </div><br/><br/>
          <!--END SIGNATURE SECTION -->
           <br/>
         <form @submit="formSubmit">  
           <div class="col-md-12 report-border-full">
              <span class="report-header-decision"><i class="fa fa-balance-scale"></i>&nbsp;&nbsp;&nbsp;NOTICE OF DECISION</span>
           </div> 
           <div class="report-gatter"></div>
           <div class="col-md-12 report-border-full">
              <div class="form-group"><br/>
                <b>HR/Admin Department Decision:</b>
                  <textarea  rows="10" class="form-control notice-decision" v-model="notice_for_decision"></textarea>
               </div>
           </div>
           <br/>
           <br/>
           <div class="float-right">   
              <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Request</button>
           </div>
           <br/>
           <br/>
         </form>
          <p>HR FORM NO. 0005</p>
       </div>
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card,
  },

  data() {
    return {
      //ITEMS
      item: [],
      notice_for_decision:''
    }
  },

  mounted: function () {
    this.getItem()
  },

  methods: {

    getItem() {
      axios.get('api/nterequestbyhr/get/' + this.$route.params.id)
      .then(resp => {
        this.item = resp.data;
        console.log(JSON.stringify(resp.data));
      });
    },

    formSubmit(e){
      e.preventDefault()

     // alert(this.item.id);
      this.$swal({
          title: 'Are you sure?',
          text: 'Do you want to submit this request',
          type: 'warning',
          showCancelButton: true,
          showCloseButton: false,
        })
        .then((isConfirm) => {
          if (isConfirm === true) {
            axios.post('api/notice/for/decision/' + this.item.id , {
                id:this.item.id,
                notice_for_decision: this.notice_for_decision
              })
              .then(resp => {
                this.$swal('Success', 'You successfully submitted this request.', 'success')
                this.$router.push({
                  name: 'nte-request'
                })
              })
              .catch(error => {
                if (error.response.status == 422) {
                  this.error_handler = error.response.data.errors
                }
                console.log('response => ', error.response);
              });
          }
        });
    }
  },
  
}
</script>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-notice-for-decision.vue